import HomeAgents from "../../components/organisms/HomeAgents";

function AgentsHome() {
  return (
    <>
      <HomeAgents />
    </>
  );
}

export default AgentsHome;
